import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { refreshToken, setLogin, closeSession, setCaptcha, setForgetPassword, setChangePassword, structureRolesAndPrivilegesApi } from './authAPI';

const initialState = {
  user: "idle",
  status: 'idle',
  messageError: "idle",
  emailPasswordExpired: "idle",
  passwordValidityTime: 0,
  statusLogin: "idle",
  statusCurrent: "idle",
  codeErrorShowCurrent: "",
  statusCaptcha: "idle",
  statusLogout: "idle",
  resultCaptcha: "",
  resultTime: 0,
  auth: {},
  responseForgetPassword: "",
  statusForgetPassword: "",
  messageErrorChangePassword: "",
  statusChangePassword: "",

  statusStrucutureSession: "idle",
  strucutureSession: "",
  messageErrorStructureSession: "",
};

export const login = createAsyncThunk(
  'auth/login',
  async (data, { rejectWithValue }) => {
    const response = await setLogin(data);

    if (response.status === 'error' && response.data && response.data.data) {
      return rejectWithValue({
        message: response.data.message,
        email: response.data.data.email,
        daysTemp: response.data.data.daysTemp
      })
    } else if (response.status === 'error') {
      throw ({ message: response.data.message })
    }
    return response.data;
  }
)

export const captcha = createAsyncThunk(
  'auth/captcha',
  async (data) => {
    const response = await setCaptcha(data);
    if (response.status === 'error') throw ({ message: response.data.message })
    return response;
  }
)

export const showCurrent = createAsyncThunk(
  'auth/current',
  async (data, { rejectWithValue }) => {
    const response = await refreshToken()
    if (response.status === 'error' && response.data && response.data.informationCode) {
      return rejectWithValue({
        message: response.data.message,
        informationCode: response.data.informationCode
      })
    }
    else if (response.status === 'error') throw ({ message: response.data.message })
    return response.data;
  }
);
export const logout = createAsyncThunk(
  'auth/logout',
  async () => {
    const response = await closeSession();
    if (response.status === 'error') throw ({})
    return response.data;
  }
);

export const forgetPassword = createAsyncThunk(
  'auth/forget-password',
  async (data) => {
    const response = await setForgetPassword(data);
    if (response.status === 'error') throw ({ message: response.data.message })
    return response.data;
  }
);

export const changePassword = createAsyncThunk(
  'auth/change-password',
  async (data) => {
    const response = await setChangePassword(data);
    if (response.status === 'error') throw ({ message: response.data.message })
    return response.data;
  }
);

export const structureRolesAndPrivileges = createAsyncThunk(
  'auth/structure-roles-privileges',
  async (data) => {
    const response = await structureRolesAndPrivilegesApi(data);
    if (response.status === 'error') throw ({ message: response.data.message })
    return response;
  }
)

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    reset: () => initialState,
    clearErrorMessageChangePassword: (state) => {
      state.statusChangePassword = "idle";
      state.messageErrorChangePassword = "";
    },
    clearErrorMessageForgetPassword: (state) => {
      state.statusForgetPassword = "idle";
      state.responseForgetPassword = "";
    },
    clearErrorMessageLogin: (state) => {
      state.statusLogin = "idle";
      state.messageError = "";
    },
    clearDataLoginWhenPasswordExpired: (state) => {
      state.emailPasswordExpired = "idle";
      state.passwordValidityTime = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.statusLogin = 'loading';
      })
      .addCase(login.fulfilled, (state, action) => {
        state.statusLogin = 'finished';
        state.user = action.payload;
      })
      .addCase(login.rejected, (state, action) => {
        state.statusLogin = 'failed';
        state.messageError = action.payload && action.payload.message ? action.payload.message : action.error.message;
        state.emailPasswordExpired = action.payload && action.payload.email ? action.payload.email : "idle";
        state.passwordValidityTime = action.payload && action.payload.daysTemp ? action.payload.daysTemp : 0;
      })
      .addCase(captcha.pending, (state) => {
        state.statusCaptcha = 'loading';
      })
      .addCase(captcha.fulfilled, (state, action) => {
        state.statusCaptcha = 'finished';
        state.resultCaptcha = action.payload;
      })
      .addCase(captcha.rejected, (state, action) => {
        state.statusCaptcha = 'failed';
      })
      .addCase(showCurrent.pending, (state) => {
        state.statusCurrent = 'loading';
      })
      .addCase(showCurrent.fulfilled, (state, action) => {
        state.statusCurrent = 'finished';
        state.resultTime = action.payload;
      })
      .addCase(showCurrent.rejected, (state, action) => {
        state.statusCurrent = 'failed';
        state.messageShowCurrent = action?.payload?.message || action.error.message;
        state.codeErrorShowCurrent = action?.payload?.informationCode || '401';
      })
      .addCase(forgetPassword.fulfilled, (state, action) => {
        state.responseForgetPassword = action.payload.message;
        state.statusForgetPassword = "success";
      })
      .addCase(forgetPassword.rejected, (state, action) => {
        state.responseForgetPassword = action.error.message;
        state.statusForgetPassword = "failed";

      })
      .addCase(changePassword.pending, (state) => {
        state.statusLogin = 'loading';
      })
      .addCase(changePassword.fulfilled, (state, action) => {
        state.statusChangePassword = 'finished';
        // state.user = action.payload;
      })
      .addCase(changePassword.rejected, (state, action) => {
        state.statusChangePassword = 'failed';
        state.messageErrorChangePassword = action.error.message;
      })
      .addCase(logout.rejected, (state, action) => {
        state.statusLogout = 'failed';
      })
      .addCase(structureRolesAndPrivileges.pending, (state) => {
        state.statusStrucutureSession = 'loading';
      })
      .addCase(structureRolesAndPrivileges.fulfilled, (state, action) => {
        state.statusStrucutureSession = 'finished';
        state.strucutureSession = action.payload;
      })
      .addCase(structureRolesAndPrivileges.rejected, (state, action) => {
        state.statusStrucutureSession = 'failed';
        state.messageErrorStructureSession = action.error.message;
      })

  },
});

export const { reset, clearErrorMessageChangePassword, clearErrorMessageForgetPassword, clearErrorMessageLogin, clearDataLoginWhenPasswordExpired } = authSlice.actions;

export const selectStatus = (state) => state.auth.status;
export const selectStatusLogin = (state) => state.auth.statusLogin;
export const selectStatusCurrent = (state) => state.auth.statusCurrent;
export const selectResultTime = (state) => state.auth.resultTime;
export const selectMessageShowCurrent = (state) => state.auth.messageShowCurrent;
export const selectCodeErrorShowCurrent = (state) => state.auth.codeErrorShowCurrent;
export const selectUser = (state) => state.auth.user;
export const selectStatusCaptcha = (state) => state.auth.statusCaptcha;
export const selectResultCaptcha = (state) => state.auth.resultCaptcha;
export const selectMessageError = (state) => state.auth.messageError;
export const selectEmailPasswordExpired = (state) => state.auth.emailPasswordExpired;
export const selectPasswordValidityTime = (state) => state.auth.passwordValidityTime;
export const selectResponseForgetPassword = (state) => state.auth.responseForgetPassword;
export const selectStatusForgetPassword = (state) => state.auth.statusForgetPassword;
export const selectStatusChangePassword = (state) => state.auth.statusChangePassword;
export const selectStatusstatusLogout = (state) => state.auth.statusLogout;
export const selectMessageErrorChangePassword = (state) => state.auth.messageErrorChangePassword;

export const selectStatusStrucutureSession = (state) => state.auth.statusStrucutureSession;
export const selectStrucutureSession = (state) => state.auth.strucutureSession;
export const selectMessageErrorStructureSession = (state) => state.auth.messageErrorStructureSession;
export default authSlice.reducer;
